export default [
  {
    path: "studio",
    name: "studio",
    component: () => import("@/views/adminPanel/pages/studio/Studio.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "studio/social",
    name: "studio-Social",
    component: () => import("@/views/adminPanel/pages/social/Social.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "studio/payment",
    name: "studio-Payment",
    component: () => import("@/views/adminPanel/pages/payment/Payment.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "studio/chat",
    name: "studio-chat",
    component: () =>
      import("@/views/adminPanel/pages/studio/chatmodule/ChatModule.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "studio/my-request",
    name: "studio-Myrequest",
    component: () =>
      import("@/views/adminPanel/pages/studio/components/MyRequest.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "studio/my-assets",
    name: "studio-Myassets",
    component: () =>
      import("@/views/adminPanel/pages/studio/components/MyAssets.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "order-confirm",
    name: "orderConfirm",
    component: () =>
      import("@/views/adminPanel/pages/payment/OrderConfirm.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "Meta",
    name: "Meta",
    component: () => import("@/views/adminPanel/pages/meta/Meta.vue"),
    meta: {
      rule: "editor",
    },
  },
];
